import { useCallback, useContext } from 'react';
import _get from 'lodash/get';

import { AuthContext } from 'context/AuthContext';
import useEcomPlatform from './useEcomPlatform';

export default function useRetailer() {
  const { storeProperties } = useContext(AuthContext);
  const { checkIfPlatformIs } = useEcomPlatform();

  const getStoreProperty = useCallback(
    (property, defaultValue) => _get(storeProperties, property, defaultValue),
    [storeProperties]
  );

  const isSSRStore = getStoreProperty('is_ssr_retailer', false);
  const isAdvancedMode = !checkIfPlatformIs('SS_GENERIC_ECOM');

  return {
    isSSRStore,
    isAdvancedMode: isSSRStore ? isAdvancedMode : true,
    getStoreProperty
  };
}
